/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreatePropertyMaintenanceExpenseItem { 
    description_line_1: string;
    description_line_2?: string;
    /**
     * The gross amount involved in this line item including Normal VAT rate.
     */
    gross_amount: number;
}

